import React from 'react';
import { SplineChart } from '../../../../../../../../CommonComponents/OPL/charts/SplineChart/SplineChart';

export const MemoSplineChart = React.memo(SplineChart);
